import { UseFormMethods } from 'react-hook-form';
import React from 'react';
import ButtonGroup from '@material-ui/core/ButtonGroup/ButtonGroup';
import Button from '@material-ui/core/Button/Button';
import { useRemainingShares } from '../../use-owner-shares';
import { BuyProcessFormNextButton } from '../../../buy-process-form-next-button/buy-process-form-next-button';
import { BuyProcessFormAdminSubmitButton } from '../../../buy-process-form-admin-submit-button/buy-process-form-admin-submit-button';
import { GenericFn } from '../../../../../../utils/types';

type Props = {
  control: UseFormMethods['control'];
  onBack: GenericFn;
  onForward: GenericFn;
  isLoading: boolean;
};

export const OwnerSharesSubmitButton = (props: Props) => {
  const remainingShares = useRemainingShares(props.control);

  return (
    <ButtonGroup>
      <Button disabled={remainingShares !== 0} onClick={props.onBack}>
        Tillbaka
      </Button>
      <BuyProcessFormNextButton
        disabled={remainingShares !== 0}
        onClick={props.onForward}
      >
        Nästa
      </BuyProcessFormNextButton>
      <BuyProcessFormAdminSubmitButton
        loading={props.isLoading}
        disabled={remainingShares !== 0}
      >
        Spara
      </BuyProcessFormAdminSubmitButton>
    </ButtonGroup>
  );
};
